import React from "react";
import Blog_50_1 from "../component/Blog_50_1";
function Blog_50_1_container() {
  return <Blog_50_1 />;
}

export default Blog_50_1_container;
